module.exports = __webpack_public_path__ + "static/img/fingerpost_express_2.f92c45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_express_2.jpg
// module id = 4XtN
// module chunks = 0